<div class="maintenance-container">
  <h1 class="maintenance-title">Systemwartung</h1>

  <p class="maintenance-message">
    Das System wird derzeit gewartet, um Ihre Erfahrung zu verbessern.
    Bitte versuchen Sie es später erneut.
  </p>

  <div class="maintenance-thank-you">
    Vielen Dank für Ihre Geduld.
  </div>

  <img
    alt="logo"
    class="maintenance-logo"
    [src]="
      isDarkMode
        ? 'https://kf.dev.valuecloud.io/assets/layout/images/ea_logo_dark.svg'
        : 'https://kf.dev.valuecloud.io/assets/layout/images/ea_logo_light.svg'
    "
  />
</div>
